export default __webpack_public_path__ + "media/environment_friendly_1.8e1ef171.png";